
import { Component, Vue } from 'vue-property-decorator'
import appBar from '@/components/AppBar.vue'
import { ApplicationList } from '../models/ApplicationList'
import { SearchCondition } from '../models/ApplicationListSearchCondition'

@Component({
	components: { appBar }
})
export default class ApplicationListView extends Vue {
	//#region 変数
	private menu = false
	//private noApp = true
	private search = ''
	private data = false
	//private menuTo = false
	private searchCondition: SearchCondition = new SearchCondition()
	//#region メッセージ
	private showMessage = false
	private messageType = 'info'
	private message = ''

	private v_noApp = ''

	private appList: ApplicationList[] = []

	private headers = [
        {
            text: '詳細',
            value: 'edit',
            width: '3%',
            class: 'sticky-header primary white--text px-1',
            divider: true,
            sortable: false,
            align: 'center'
        },
		{
			text: '申請日',
			value: 'date',
			width: '3%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
            align: 'center'
		},
		{
			text: '申請者',
			value: 'empNm',
			width: '15%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'left'
		},
		{
			text: '種類',
			value: 'type',
			width: '10%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'left'
		},
		{
			text: '概要',
			value: 'summary',
			width: '28%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'left'
		},
		{
			text: '特記事項',
			value: 'remarks',
			width: '27%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
			sortable: false,
			align: 'left'
		},
		{
			text: '承認',
			value: 'app',
			width: '5%',
            class: 'sticky-header primary white--text px-1',
			divider: true,
			align: 'center'
		}
 //非表示にしたい列は、ヘッダー自体定義しない
 //       {
 //           text: '年月',
 //           value: 'workingym',
 //           width: '3%',
 //           class: 'sticky-header primary white--text px-1',
 //           divider: true,
 //           sortable: false,
 //           align: 'center'
 //       },
 //       {
 //           text: 'ID',
 //           value: 'empCd',
 //           width: '3%',
 //           class: 'sticky-header primary white--text tpx-1',
 //           divider: true,
 //           sortable: false,
 //           align: 'center'
 //       }
	]
	//#endregion

	private selectedEmp: ApplicationList = new ApplicationList()

	// #region 初期表示
	private async created() {
		this.searchCondition.noApp = true
		//画面表示時の年月From・Toの初期値はシステム日付
		//const defValue = new Date().toISOString().substr(0, 7)
		if (this.$route.params.dateFrom == null) {
			this.searchCondition.sdate = ''
		} else {
			this.searchCondition.sdate = this.$route.params.dateFrom
		}
		if (this.$route.params.dateTo == null) {
			this.searchCondition.noApp = true
		} else {
			if (this.$route.params.dateTo == '0') {
				this.searchCondition.noApp = false
			} else {
				this.searchCondition.noApp = true
			}
		}
		this.search = this.$route.params.searchString

		//メッセージ
		this.clearMessage()

		this.getList()
		//画面上部へスクロール
		window.scrollTo({ top: 0, behavior: 'smooth' })
	}
	//#endregion
	//#region 年月変更
	private changeYm() {
		//初期化
		//メッセージ
		this.clearMessage()

		this.getList()
	}
	//#endregion

    //#region 未承認チェックボックス変更
	private changeNoApp() {
        var nowDate = new Date()
        var year = nowDate.getFullYear()
        var month = ("0" + (nowDate.getMonth() + 1)).slice(-2)

        if (this.searchCondition.noApp == false && this.searchCondition.sdate == '') {
            this.searchCondition.sdate = year + '-' + month
        }

        this.changeYm()
    }
	//#endregion

	// #region 閉じるボタン押下
	private close() {
		console.log('閉じる')
	}
	//#endregion

	//#region プライベート
	//#region 申請一覧取得
	private async getList() {
		try {
            this.appList = []	//検索結果無しのときに過去分が出ないように初期化
			const sdata = { SearchCondition: this.searchCondition }
			const response = await this.$axios.post('api/ApplicationList/Search', sdata)
			//メッセージがある場合表示
			if (response.data.messageData.messageList.length > 0) {
				this.showMessage = true
				this.message = response.data.messageData.messageList[0]
				response.data.messageData.errFlg ? (this.messageType = 'error') : (this.messageType = 'success')
				return
			}
			this.appList = response.data.searchResult
		} catch (e) {
			console.log(e.message)
		}
	}
	//#endregion
	//#region エラーメッセージ
	private errorMessage(message: string) {
		this.showMessage = true
		this.messageType = 'error'
		this.message = message
	}
	//#endregion

	//#region 行クリック
    private clickRow(workingym: string, empCd: string, type:string) {
		if (this.searchCondition.noApp == true) {
			this.v_noApp = '1'
		} else {
			this.v_noApp = '0'
		}

        this.$router.push({
            name: 'WorkingList',
            params: {
                workingYm: workingym.replace('-', ''),
                empCd: empCd,
                beforeViewName: 'ApplicationList',
                beforeViewParam1: this.searchCondition.sdate,
                beforeViewParam2: this.v_noApp,
                beforeViewParam3: this.search
            }
        })
		//#endregin
	}
	//#region メッセージクリア
	private clearMessage() {
		this.message = ''
		this.showMessage = false
	}
	//#endregion

    // #region 一覧再描画ボタン押下
    private refresh() {
        this.getList()
    }
	//#endregion
	//#endregion
}
